var Item = /** @class */ (function () {
    function Item(_name, _activeStates, _images) {
        this._name = _name;
        this._activeStates = _activeStates;
        this._images = _images;
        this._state = 0;
    }
    Object.defineProperty(Item.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "activeStates", {
        get: function () {
            return this._activeStates;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "images", {
        get: function () {
            return this._images;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "stateCount", {
        get: function () {
            return this._activeStates.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "isActive", {
        get: function () {
            return this._activeStates[this._state];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "image", {
        get: function () {
            return this._images[this._state];
        },
        enumerable: true,
        configurable: true
    });
    return Item;
}());
export { Item };
